<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-100">
      >
      <login-card>
        <div slot="login-header" class="login-header-wrapper">
          <h3 class="page-title">Log Into Admin Portal</h3>
          <a v-bind:href="currentPage.otherLogin">
            <h5 class="other-login">Go to Project Portal Login</h5>
          </a>
        </div>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Password...</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>
        <md-button
          @click="adminLogin"
          slot="footer"
          class="md-simple md-success md-lg"
          v-bind:href="currentPage.loginLink"
        >
          Log into Admin Portal
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
export default {
  components: {
    LoginCard
  },
  data() {
    return {
      email: null,
      password: null,
      isAdmin: false,
      currentPage: {
        loginLink: "#/adminportal",
        otherLogin: "#/portallogin"
      }
    };
  },
  methods: {
    adminLogin() {
      this.$store
        .dispatch("signIn", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          console.log("in the admin login then");
          this.errors = {};
          this.$router.push("project");
        })
        .catch(errors => {
          console.log("eorrorrrororrs");
          this.errors = errors;
          console.log(errors);
        });
    }
  }
};
</script>

<style></style>
